/**
 * @file   src\Pages\Buy Subscription.tsx
 * @brief  Buy Subscription page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, useState , useParams, Link, useEffect, useLocation, useNavigate} from "../utils/thirdpartyComponents";
import { Accordion } from "react-bootstrap";
import CWFooter from "src/components/CWFooter";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import referfriendicon from "../assets/images/refer-and-earn-img.svg";
import copyicon from "../assets/images/copy-promo-code.svg";
import shareicon from "../assets/images/share-icon.svg";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import ShareModal from '../components/ShareModal';
import copy from 'clipboard-copy'
import { MessageToaster } from "src/utils/toastUtil";
import axios from '../config/axiosConfig';
import {ProfileApi, UserApi} from "../utils/apiUrls";
import SmallLoader from '../components/SmallLoader';
import CWInputGroup from "src/components/CWInputGroup";
import CWInput from "src/components/CWInput";

const ReferFamily = () => {
    // Instantiate MessageToaster
    const toaster = new MessageToaster();
      const navigate = useNavigate();

      // Route information variable
      const params = useParams();
       const location = useLocation();
    const { isParentUser, userHasActiveSubscription} = location.state || {};
    const [showModal, setShowModal] = useState(false);
    // State to set referral
    const [referralCode, setReferralCode] = useState('');
    const [newFamilyCode, setNewFamilyCode]  = useState('');
    const [totalReferredCount, setTotalReferredCount] = useState(0);
    const [totalFreeWashThroughReferral, setTotalFreeWashThroughReferral] = useState(0);
    const [loading, setLoading] = useState(false);
    const [referralCodeDescription, setReferralCodeDescription] = useState('');
    const [referralCodeSettings, SetReferralCodeSettings] = useState<any>(null);
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const handleCopyCode = () => {
        // copy refferal code
        copy(referralCode);
        // show success message
        toaster.toastSuccess("Code copied to clipboard!")

    };


    useEffect(() => {
        fetchReferralData();
    }, []);

    const applyFamilyCode = async () => {
        // event.preventDefault();
            try {
              setLoading(true);
              const payload = {
               familyCode: newFamilyCode
              };
              const response = await axios.post(UserApi.APPLY_FAMILY_CODE, payload);
              if (response?.data?.error === 0) {
                toaster.toastSuccess("Family code has been applied successfully");
                navigate(`/${params.carwashname}/${pageURLs.settings}`);
              } else {
                toaster.toastError(response?.data?.message || 'Update failed');
              }
            } catch (error: any) {
              console.log(error)
            } finally {
              setLoading(false);
            }
    }


    const fetchReferralData = async () => {
        // Instantiate MessageToaster
        const toaster = new MessageToaster();
        setLoading(true)
        try {
          const responseProfile = await axios.get(ProfileApi.USER_FAMILY_REFERRAL_FETCH);
          setLoading(false)
          if (responseProfile?.data?.error === 0) {
            setReferralCode(responseProfile?.data?.data?.UserFamilyReferralData?.FamilyCode);
        
            // setReferralCodeDescription(responseProfile?.data?.data?.ReferralSettingsData?.Description);
            // SetReferralCodeSettings(responseProfile?.data?.data?.ReferralSettingsData)
          } else {
            toaster.toastError(responseProfile?.data?.message);
            setReferralCode('');
            setReferralCodeDescription('')
          }
        } catch (error: any) {
            setLoading(false)
            setReferralCode('');
            setReferralCodeDescription('')
          throw new Error(error?.response?.data?.message || error?.message);
        }
      };

    return (

        <div className="common-content-wrap pb-170">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/"+params.carwashname+"/"+pageURLs.settings} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Family Plan
                        </div>
                    </div>
                </div>
                <div className="main-content-wrap pe-0 ps-0 pt-0">
                    {/* {!isParentUser ? 
                    
                        <div className="main-content-wrap pe-0 ps-0 pt-0">
            <div className="profile-content-wrap">
                <p>Are you a child user? Enter your Family Code below and click Apply to join your Family Plan.</p>
                        <CWInputGroup
                            id="appliedReferralCode"
                            name="appliedReferralCode"
                            placeholder={"Family Code"}
                            type="number"
                            label={"Family Code"}
                            // errorMessage={errors.referralCode && errors.referralCode}
                            //inputIcons={enableIcon ? TickIcon : ""}
                            onChange={(e)=>setNewFamilyCode(e.target.value)}
                            // disabled={couponCodeFldDisable}
                            value={newFamilyCode}
                        />
                        <Button  className="primary-btn btn-main" title='Apply' onClick={() => applyFamilyCode()}>Apply</Button>
                        
                        </div>
                    </div>:""} */}
                    <div className="refer-friend-wrap text-center">
                      
                        <div className="refer-img"><img src={referfriendicon} alt="Car Wash App" /></div>
                        <h1>Family Plan</h1>
                         {!isParentUser ? 
                    !userHasActiveSubscription ?
                        <div className="main-content-wrap pe-0 ps-0 pt-0">
            {/* <div className="profile-content-wrap"> */}
                <p>Enter your Family Code to link your account and start saving!</p>
                        <div className="family-code-input position-relative">
                            <CWInput
                                id="appliedReferralCode"
                                name="appliedReferralCode"
                                placeholder={"Family Code"}
                                type="number"
                                label={""}
                                // errorMessage={errors.referralCode && errors.referralCode}
                                //inputIcons={enableIcon ? TickIcon : ""}
                                onChange={(e)=>setNewFamilyCode(e.target.value)}
                                // disabled={couponCodeFldDisable}
                                value={newFamilyCode}
                            />
                            <Button  className="primary-btn btn-main" title='Apply' onClick={() => applyFamilyCode()}>Apply</Button>
                        </div>
                        
                        </div> : <><p className="sub mb-4">You already have an active subscription. Please ask the car wash owner to delete your current subscription if you wish to join a Family Plan.</p>
<Button
  variant="primary"
  className="primary-btn btn-main"
  onClick={() => navigate("/" + params.carwashname + "/" + pageURLs.contactus)}
>
  Contact Us
  {/* <img src={shareicon} alt="Car Wash App" /> */}
</Button></>
                    :""}
                    <div className="main-content-wrap pe-0 ps-0 pt-4">
                        <p className="sub">Share your code with family members to help them save money.</p>
                        <div className="referral-code-block d-flex justify-content-center align-items-center mb-4">
                            <p>Family Code <span>{referralCode}</span></p>
                            <span onClick={handleCopyCode}><img src={copyicon} alt="Car Wash App" /></span>
                        </div>
                        <Button variant="primary" className="primary-btn btn-main" onClick={handleShow}>Share to Family Member<img src={shareicon} alt="Car Wash App" /></Button>
                    </div>
                    </div>
                </div>
            </div>
            <div className="accordion-fixed-wrap">
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How it Works</Accordion.Header>
                        <Accordion.Body>
                            Want to extend the benifits of the family plan to your family members too? All they need to do is sign up with your code and use your card information at checkout to purchase car washes at discounted rates. 
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
            {loading && <SmallLoader />}
            <CWFooter activeLink="Settings"/>
            {referralCode ? <ShareModal show={showModal} handleClose={handleClose} type="FC" referralCode={referralCode} referralCodeDescription = {referralCodeDescription} titleText="Family Plan" paraText="Share your code with family members to help them save money."/> : ''}
        </div>
    )
}

export default ReferFamily;
